import { render } from "./gsgy.vue?vue&type=template&id=776e0455&scoped=true&ts=true"
import script from "./gsgy.vue?vue&type=script&lang=ts"
export * from "./gsgy.vue?vue&type=script&lang=ts"

import "./gsgy.vue?vue&type=style&index=0&id=776e0455&lang=less&scoped=true"

import exportComponent from "E:\\operationmanualNew\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-776e0455"]])

export default __exports__